<template>
  <div class="bg-light-gray w-screen min-h-screen flex justify-center items-center px-4 py-10">
    <div class="w-full max-w-sm px-2 py-10 flex flex-col items-center gap-7">
      <div>
        <h1 class="text-2xl font-bold text-blue-100 text-center leading-tight">
          {{ title }}
        </h1>
        <img v-if="['valid', 'duplicate','redirect'].includes(responseStatus)" src="@/assets/email-verified.svg"/>
        <img v-else src="@/assets/email-unverified.svg"/>
      </div>
      <p class="text-lg text-mid-gray text-center leading-relaxed">
        {{ content }}
      </p>

      <button v-if="responseStatus != 'redirect'"
        @click="goToTroopers"
        class="w-full bg-orange-100 hover:bg-orange-110 active:bg-orange-shadow text-white font-bold text-xl py-4 rounded-full uppercase tracking-widest transition-colors duration-200"
      >
        Go to Troopers
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'EmailVerification',
  data() {
    return {
      responseStatus: "invalid", // enum: invalid, valid, expired, duplicate
    }
  },
  computed: {
    title() {
      switch (this.responseStatus) {
        case 'redirect': return 'Email Already Verified'
        case 'valid': return 'Email Verified Successfully'
        case 'expired': return 'Verification Link Expired'
        case 'duplicate': return 'Email Already Verified'
        default: return 'Email Verification Failed'
      }
    },
    content() {
      switch (this.responseStatus) {
        case 'redirect': return 'Your email has been verified. Open Troopers App to check your email status.'
        case 'valid': return 'Congrats! Your email has been verified. Click the button below to continue using Troopers App.'
        case 'expired': return 'Your verification link has expired. Please request a new one.'
        case 'duplicate': return 'Your email has already been verified. Click the button below to continue using Troopers App.'
        default: return 'Uh-oh, something went wrong while trying to verify your email. Please try again.'
      }
    },
  },
  methods: {
    ...mapActions({
      verifyEmail: "verifyPTEmail",
    }),
    goToTroopers() {
      const url = process.env.VUE_APP_EMAIL_VERIFICATION_DEEPLINK;
      if (!url) return;
      window.open(url, '_blank');
    }
  },
  created() {
    if(!this.$route.query.token){
      this.responseStatus = 'redirect';
      return;
    }
    this.verifyEmail(this.$route.query.token).then((res) => {
     if(res.code === 200) {
      this.responseStatus = 'valid';
     }
    }).catch((err) => {
      switch (err.response.data.code) {
        case 410: this.responseStatus = 'expired'; break;
        case 409: this.responseStatus = 'duplicate'; break;
      }
    })
  }
}
</script>

<style scoped>
</style>
